import styled from "styled-components"

export const SendConfirmationWrapper = styled.div`
    display: flex;
    flex-direction: column;

    font-size: 14px;
    line-height: 16px;

    & > div {
        display: flex;
        align-items: baseline;
    }

    & > div:not(:last-child) {
        margin-bottom: 11px;
    }

    svg {
        margin-right: 8px;

        font-size: 12px;
    }
`

export const Slider = styled.div`
    &&& {
        margin-top: 15px;
        margin-bottom: 25px;
        display: block;
    }
`

export const ABTestedFromWrapper = styled.div`
    display: flex;
`

export const VariantFrom = styled.div`
    display: flex;
    flex-direction: column;
    gap: 11px;
`
